export const GLOBAL_STATE = 'Group'

export const GROUP_ALL = 'groupAll'
export const GROUP_GROUPING = 'groupGrouping'
export const GROUP_SHUFFLE = 'groupShuffle'
export const GROUP_STUDENT_TRANSFER = 'groupStudentTransfer'
export const GROUP_ASSIGN_TEACHER = 'groupAssignTeacher'
export const GROUP_ASSIGNED_LIST = 'groupAssignedTeacherList'
